module.exports = __webpack_public_path__ + "static/media/Corazon_Aquino_1986_compressed.b0e1850a.jpg";